<iframe 
  [src]="trustedNextAppUrl" 
  class="embedded-next"
  title="Matrix Web Application"
  style="width: 100%; height: calc(100% - 16px)">
</iframe>